module.exports = __webpack_public_path__ + "img/avatar0.79873da0.png";